import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Shop = () => {
    const [data, setData] = useState(null); 
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null);

    const fetchData = async () => {
        try {
            const response = await axios.get('https://dog.ceo/api/breeds/image/random'); 
            setData(response.data); 
        } catch (error) {
            setError(error.message); 
        } finally {
            setLoading(false); 
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center">
            <h1 className="text-3xl font-bold text-blue-600 mb-6">Shop</h1>
            
            {loading && (
                <p className="text-lg text-gray-500 animate-pulse">Loading...</p>
            )}
            
            {error && (
                <p className="text-lg text-red-500">
                    Error: {error}
                </p>
            )}
            
            {data && (
                <div className="bg-white p-6 shadow-md rounded-lg text-center">
                    <h2 className="text-xl font-semibold mb-4">Random Dog Image</h2>
                    <img 
                        src={data.message} 
                        alt="A random dog" 
                        className="w-72 h-72 object-cover rounded-lg mx-auto" 
                    />
                </div>
            )}
        </div>
    );
};

export default Shop;
